import React from 'react'
import { Button, Form } from 'react-bootstrap'
import Successfull_Modal from '../../common_components/common_modal/successfull_modal/Successfull_Modal';
import Success_Lottie from '../../animations/success_lottie/Success_Lottie';
import Proceed_btn from '../../common_components/common_btn/proceed_btn/Proceed_btn';

function Deposit_tab_contant() {
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <>
            <section className='Withdraw_tab_contant'>
                <div className="wallet-input-box withdraw-box">
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Enter Amount</Form.Label>
                            <Form.Control type="email" placeholder="Enter Amount" value="₹" />
                        </Form.Group>

                    </Form>
                </div>

                <Proceed_btn btnText="Proceed" onClick={() => setModalShow(true)}/>

                <p className="wallet-warning">
                    ⚠️ Ensure you enter the <span> CORRECT AMOUNT </span> before confirming.
                </p>



            </section>

            <Successfull_Modal
                show={modalShow}
                message=" Deposit Successful!"
                subMessage="Your payment has been received & the amount is now added to your wallet.."
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />

        </>
    )
}

export default Deposit_tab_contant